
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`This is brought by the
                    <a href="${0}">Folksonomy Engine project</a>. Don't
                    hesitate to participate or give feedback`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`Ovaj alat vam omogućuje ispravljanje popisa sastojaka. Možete dodati, ukloniti ili urediti
                popis sastojaka.
                <br>
                Ovaj znak <span class="highlight">␣</span> predstavlja razmak.
                <br>
                Ovaj znak <span class="highlight">↩︎</span> predstavlja prijelom retka. `,
'hb28f1f2ec1744ee9': html`Ova svojstva kreiraju i pohranjuju korisnici za bilo koju vrstu upotrebe. Slobodno dodajte svoja
                    . Svojstva i vrijednosti koje kreirate
                    <strong>moraju biti činjenične</strong>. Možete se udubiti u
                    <a href="${0}">popis svojstava koja zajednica već koristi</a>
                    ili istražiti
                    <a href="${1}">dokumentaciju svojstava i njihovu tražilicu</a>.`,
's000a5b76bd3a01c2': `Učitavanje svojstava...`,
's000d98595e959c1e': `Preuzmi na Google Playu`,
's013bdc8cf0d3583d': `Pomozite nam sa sastojcima`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `Validiraj usjev`,
's03e9c8114521b998': `Uredit ću sastojke`,
's05ec315d9308091a': `Ikona kutova barkoda`,
's061eb5af92512c85': `Spremljeno! Možete li pomoći s još jednim?`,
's06847c221c4c0bc1': `Želio bih stvoriti svojstvo za [opišite svoj slučaj upotrebe]...`,
's06f6c6f99db6b552': `Izvornik`,
's081e2ad82db71e1d': `Grupirane vrijednosti`,
's09205907b5b56cda': `Ne`,
's0b4235aae602a950': `namjenska dokumentacija`,
's0bb2d48532acc455': `Preuzmi CSV`,
's0d5b7fee0311db68': `Property`,
's0fb218abc2e157ed': `Poništi sliku`,
's100c4928cc74642a': `podržati napredak istraživanja javnog zdravstva.`,
's10db5498186c083b': `Otkaži obrezivanje`,
's11a18a69b30b65ed': `Pomozite nam ispraviti greške u popisu sastojaka`,
's1205d5f6fccf8e69': `Vrijednost nekretnine`,
's15d64a0a6715285a': `Novi ključ`,
's166bd56d19670a72': `Zoom`,
's19059bf0c4f7c162': `Područje odabira`,
's1a52515ec8ddade8': `Product barcode`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `Pomozite nam ispraviti nutritivne informacije`,
's1e00019dc454872d': `Molimo navedite naziv svojstva pomoću atributa property-name.`,
's1e49126af0935a5b': `Popis proizvoda koji koriste ovo svojstvo`,
's21e73088de6f26f3': `Preuzmite na App Storeu`,
's255857544a9d5ec0': `Reset`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `Otkaži`,
's2db7b654c0a9bde0': `Dokumentirajte nekretninu`,
's300b3a6ee4e1252d': str`Loše podudaranje ${0}%`,
's33f786bb6b4f0cf4': `Rezultat obrezivanja`,
's33f85f24c0f5f008': `Spremi`,
's34be4af4e8fec4ae': `Prvo pitajte zajednicu`,
's36d86adc823cbfa6': `Prije stvaranja novog objekta, razgovarajte o tome sa zajednicom:`,
's3781d25aa51a736c': `Dokumentacija Folksonomy Enginea`,
's383ae4449428b61e': `Poništi obrezivanje`,
's39bcf88721a1e8ee': `Poništi odabir`,
's39e14e14300694c7': `Dokumentacija i smjernice`,
's3b430cfa5c1fe7f4': str`Dokumentacija za ${0}`,
's3f4e4b52f230a892': `Slika na platnu`,
's417b90913e05bc17': `Preview`,
's41f7dca46d3f1b4a': `Value`,
's422bba9636ce2489': `Sredina slike`,
's42dd66b2441566fd': `Ikona centra`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `Add a nutrient`,
's453ab0dbb9b5c777': `Promijeni veličinu desno`,
's475b08749d0706ed': `Pomozite nam informirati milijune potrošača diljem svijeta o tome što jedu`,
's49730f3d5751a433': `Loading...`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `Broj proizvoda`,
's4df2f533c0c1e7d0': `Kontrole slike`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's4f4886341969d552': `Premjesti odabir`,
's4f751fb9b3ed766c': `Stvaranje novog svojstva`,
's547c12ae169d00bc': `Available on F-Droid`,
's5560fb119e40923d': `Unesite naziv nekretnine...`,
's55d7249883a98ca1': `o ovom objektu na wiki stranici Open Food Facts`,
's565867d84c04aea2': `Filtriraj svojstva...`,
's5666afe5cd0166de': `Ispravite pogreške ili izmijenite tekst prije potvrde`,
's57472465a23b41db': `Values`,
's58e1eeea7a60ae51': `Učitavanje proizvoda...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `Pomozite nam ispraviti nutritivne informacije.`,
's5dd6f12783fca34f': `Uredi popis sastojaka`,
's5e8250fb85d64c23': `Zatvori`,
's5ed03bb1f3a15949': `Picture`,
's6306a31415aea913': `PODRŽAVAM`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `Urediti`,
's66413c24dcf680e2': `Preskočiti`,
's67ae6594857a4d57': `Thanks for your contribution!`,
's6cee7cad81dfedd1': `Obrezana slika`,
's6d7b6cdedaadfb6e': `Svaka donacija je važna! Cijenimo vašu podršku u ostvarivanju veće transparentnosti hrane u svijetu.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`Dobro podudaranje ${0}%`,
's71a5c9f4b68ef4d4': `Count`,
's74cb3d66f6a668e1': `Dokumentacija`,
's787dd11bed0dc88a': `Promijeni veličinu lijevo`,
's7ce4fd9430e80cea': `vrijednost`,
's801a05fa8e881f37': `Saznajte više o stvaranju nekretnina i smjernicama:`,
's8038273de2cf8b73': `Molimo odaberite područje za obrezivanje.`,
's839cc2908a5387f2': `Filtriraj barkodove...`,
's86197dcf3e96af64': `Pregledajte i pretražite postojeće nekretnine`,
's8a63be30a129a59c': `Promijeni veličinu dna`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `Promijeni veličinu gore desno`,
's8db84aa4bc949af2': `Dokumentirajte novu nekretninu`,
's8f839a03997a16d7': `Pogledajte proizvod`,
's901ae1e236ac45d3': `Otkaži brisanje`,
's907f7a97c6b29425': `Imajte na umu da se model podataka može mijenjati. Koristite na vlastitu odgovornost.`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `Sastojci:`,
's9a7f60fce090ecaf': `Nije uspjelo učitavanje svojstava. Pokušajte ponovno kasnije.`,
's9b87abd68fb9df45': `Nije pronađen? Izradi novi ključ {value}`,
's9c0f52425fd2f07e': `Možda se ne podudara`,
's9fc41f789c63b40d': `Products`,
'sa1fa766e0d5634d7': `Nema dostupnih rezultata`,
'sa548778b24054030': `Istražite sva svojstva iz projekta Folksonomy Engine. Ta svojstva pružaju dodatne metapodatke i uvide o proizvodima u bazi podataka Open Food Facts.`,
'sa63907958bd0ec4b': `Promijeni veličinu gore lijevo`,
'sa95b4224f685a36a': `Zatvori modalni prozor`,
'sab56a1d439576fd6': `Ikona prijedloga`,
'sac47ea2901d04c15': `Promijeni veličinu donjeg lijevog kuta`,
'sb125227d436c2925': `Potražite svoj koncept nekretnine u postojećoj bazi podataka nekretnina:`,
'sb125568d43642e6f': `Odgovorite na pitanja o proizvodu.`,
'sb1c538e038f9b214': str`Vrlo dobro podudaranje ${0}%`,
'sb28639570ff3b852': `popis svih nekretnina`,
'sb3bdd638a58d30f4': `angažirati zajednicu predanih građana,`,
'sb3cbcc1bd0fff140': `Nakon što potvrdite da vaša nekretnina ne postoji i zajednica se slaže da je korisna, prvo je morate dokumentirati na wiki stranici.`,
'sb3d4f79d9d8b71e5': `Submit`,
'sb560fa37a7bfb6c2': `Nisu pronađeni proizvodi za ovu nekretninu.`,
'sb7f72e4c8a2d3357': `Filtriraj vrijednosti...`,
'sb8178320160f84ea': `Prikaži obrezivanje`,
'sbad7d2734149470b': `Validate`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `Na sva pitanja je odgovoreno! Hvala na pomoći!`,
'sbd9a0b2293b3cd3c': `Serving size`,
'sbe472dc3c2685985': `Odgovarajuća vrijednost`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `Promijeni veličinu vrha`,
'sc1c08d0cbcc3bd24': `Ne podudara se`,
'sc52696641af72b53': `Instalirajte aplikaciju!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sc57b630a7a70c61f': `Predloženo rješenje`,
'sc681b137e8f604f7': `Potvrdi brisanje`,
'sc6daf8a31883f8b9': `Premjesti sliku`,
'sc895972c88d38ca5': `Folksonomska imovina`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `Redovi`,
'scb3b0671d7b7f640': `Nova vrijednost`,
'scb489a1a173ac3f0': `Da`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `Pridružite se Slack raspravi`,
'scdb6cad0b92721bf': `Nije pronađena nijedna nekretnina.`,
'scf23a05631f93732': `Potvrdi brisanje`,
'scfed2f270ef6a3aa': `Odaberite područje`,
'sd1022bc1ef9204f7': `Zumiranje slike`,
'sd1077c055cf9ba6b': `Pomozite nam da provjerimo popis sastojaka proizvoda.`,
'sd698d21ddecba56b': `Hej! Možete nam pomoći poboljšati informacije o proizvodu tako što ćete odgovoriti na sljedeće dijelove:`,
'sd82bc2decefa621b': `ostati neovisni od prehrambene industrije,`,
'sdb97e5976482606e': `Provjerite postoji li već nekretnina`,
'sdbf806fefc584115': `Trebali biste pronaći`,
'sdc673e73b5c13aea': `Delete`,
'sdc792b75f1edcaba': `Pomozite nam ispraviti pravopis sastojaka.`,
'sdca5deead576ceee': `Promijeni veličinu donjeg desnog kuta`,
'sdcc2555c5dde524f': `Jeste li sigurni da želite izbrisati ovu stavku? Ova se radnja ne može poništiti.`,
'se206feec7ec57b28': `per 100g`,
'se419a9ab36987490': `Poništiti`,
'se5127cf0f92e7e48': `Savjet: možete pronaći i`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `Predložit ću bolji urod`,
'seea3800e27baa686': `Pojedinačni proizvodi`,
'sefaba4adc4ec9219': `Folksonomy Properties`,
'seffa8ca49175b5f0': `Personalizirana svojstva`,
'sf44a6b3b232c28ea': str`Zamijeni trenutnu vrijednost s ${0}`,
'sf4cd86a2f5ef2588': `Barkod proizvoda`,
'sf57a61152168cc81': `Pomozite nam ispraviti detekciju sastojaka`,
'sf88b90b8ba23871c': `Nepoznato podudaranje`,
'sf9aee319a006c9b4': `Dodaj`,
'sfacbbe968fa7d773': `Naziv nekretnine:`,
'sfc40ea3d5d5aa6f8': `Vaše donacije financiraju svakodnevno poslovanje naše neprofitne udruge:`,
'sfe87465d50530725': `Odgovarajuća vrijednost`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  